import UserAddressName from "./UserAddressName";
import UserAddressLink from "./UserAddressLink";

import UserName from "../../../../auth/components/user/UserDetail/UserName";
import UserLink from "../../../../auth/components/user/UserDetail/UserLink";

import AddressName from "../../../../address/components/address/AddressDetail/AddressName";
import AddressLink from "../../../../address/components/address/AddressDetail/AddressLink";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserAddressDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="UserAddress-detail-title"
                    >
                        { label || t`User Address` }: <UserAddressName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="UserAddress-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="UserAddress-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } data-testid="userId-label" sx={{ textAlign: "left" }}><Trans>User</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="userId-value" sx={{ textAlign: "left" }}>{ data.userId ? (<UserLink id={ data.userId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="addressId-label" sx={{ textAlign: "left" }}><Trans>Address</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="addressId-value" sx={{ textAlign: "left" }}>{ data.addressId ? (<AddressLink id={ data.addressId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default UserAddressDetail;
